import backgroundColor from './backgroundColor'
import clearable from './clearable'
import clearIcon from './clearIcon'
import clearIconStyle from './clearIconStyle'
import debounce from './debounce'
import disabled from './disabled'
import flipHorizontallyIcon from './flipHorizontallyIcon'
import flipHorizontallyIconStyle from './flipHorizontallyIconStyle'
import flipVerticallyIcon from './flipVerticallyIcon'
import flipVerticallyIconStyle from './flipVerticallyIconStyle'
import fullHeight from './fullHeight'
import fullWidth from './fullWidth'
import hideActions from './hideActions'
import imageFormat from './imageFormat'
import imageHeight from './imageHeight'
import imageQuality from './imageQuality'
import imageWidth from './imageWidth'
import maxScaling from './maxScaling'
import minScaling from './minScaling'
import name from './name'
import overlayBackgroundColor from './overlayBackgroundColor'
import overlayBorderColor from './overlayBorderColor'
import overlayBorderWidth from './overlayBorderWidth'
import overlayPadding from './overlayPadding'
import readonly from './readonly'
import rotateClockwiseIcon from './rotateClockwiseIcon'
import rotateClockwiseIconStyle from './rotateClockwiseIconStyle'
import rotateCounterclockwiseIcon from './rotateCounterclockwiseIcon'
import rotateCounterclockwiseIconStyle from './rotateCounterclockwiseIconStyle'
import scalingSliderColor from './scalingSliderColor'
import uploadIcon from './uploadIcon'
import uploadIconStyle from './uploadIconStyle'
import value from './value'

export default {
  label: String,
  oversampling: Number,
  backgroundColor,
  clearable,
  clearIcon,
  clearIconStyle,
  debounce,
  disabled,
  flipHorizontallyIcon,
  flipHorizontallyIconStyle,
  flipVerticallyIcon,
  flipVerticallyIconStyle,
  fullHeight,
  fullWidth,
  hideActions,
  imageFormat,
  imageQuality,
  imageHeight,
  imageWidth,
  maxScaling,
  minScaling,
  name,
  overlayBackgroundColor,
  overlayBorderColor,
  overlayBorderWidth,
  overlayPadding,
  readonly,
  rotateClockwiseIcon,
  rotateClockwiseIconStyle,
  rotateCounterclockwiseIcon,
  rotateCounterclockwiseIconStyle,
  scalingSliderColor,
  uploadIcon,
  uploadIconStyle,
  value,
  autoclick: Boolean
}
